// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// --- RxJs
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { environment } from '../../../../environments/environment';
import { ApplicationError, ErrorMessage, InvitationModel, InvitationTypes } from '../../../models';
import { AppService } from '../app.service';
import { ParticipantGroupsBaseService } from '../survey/participant-groups-base.service';
import { RespondentReminderBaseService } from './respondent-reminder-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class RespondentReminderService extends RespondentReminderBaseService {

  constructor(
    private appService: AppService,
    private httpClient: HttpClient,
    private translate: TranslateService,
    private participantGroupsService: ParticipantGroupsBaseService,
  ) {
    super();
  }

  reminderRequest(model: InvitationModel): void {
    if (!model) {
      return;
    }

    const uri =
      environment.apiConfig.surveyApiUrl + environment.apiConfig.invitationsReminderApi;

    this.participantGroupsService.setRespondentReminderSending(model.recipientId, true);

    this.httpClient
      .post<InvitationModel>(uri, model)
      .pipe(
        retryBackoff(environment.retryConfig),
        catchError(this._handleError.bind(this, model.recipientId)),
      )
      .subscribe((invitation: InvitationModel | null) => {
        this.participantGroupsService.setRespondentLastEmailSentDate(model.recipientId);
        this.participantGroupsService.setRespondentInvitationType(model.recipientId, InvitationTypes.respondentReminder);
        this.participantGroupsService.setRespondentReminderSending(model.recipientId, false);
      });
  }

  private _handleError(respondentId: string, err: any): Observable<InvitationModel | null> {
    this.participantGroupsService.setRespondentReminderSending(respondentId, false);

    const errorMessage: string = this.translate.instant('errorMessageGenericBackend');

    const error: ApplicationError = ApplicationError.create(
      ErrorMessage.genericErrorCode,
      'RespondentReminderService',
      false,
      err
    );

    this.appService.setLastError(error);

    return of(null);
  }
}
